var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-left-side", attrs: { id: "header-right" } },
    [
      _vm.debugMode
        ? _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function () {
                  return (_vm.debugToolVisible = true)
                },
              },
            },
            [_vm._v(" Debug Mode ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection
        ? _c(
            "md-button",
            {
              staticStyle: {
                "min-width": "fit-content",
                cursor: "pointer",
                display: "flex",
              },
              attrs: { id: "email-icon-header" },
              on: {
                click: function () {
                  return this$1.$router.replace("/mails?selected=My")
                },
              },
            },
            [
              _c(
                "md-icon",
                { style: { color: _vm.darkMode ? "yellow" : "black" } },
                [_vm._v("mail")]
              ),
              _vm._v(" "),
              _vm.allUnreadMailCounts !== 0
                ? _c("SupsisBadge", {
                    attrs: {
                      badge: _vm.allUnreadMailCounts,
                      "class-name": "email-unread-count",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.CONFIG.FEATURES.HEYSUPSIS_ENABLED && _vm.isTicketPage()
        ? _c(
            "md-button",
            {
              staticClass: "custom-button header-btn btnCopilot",
              attrs: { id: "supsis-copilot" },
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeUseChatCopilot(_vm.activateCopilot)
                },
              },
            },
            [_c("img", { attrs: { src: "/static/img/copilot.png" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection ? _c("TodayEvent") : _vm._e(),
      _vm._v(" "),
      !_vm.blockedConnection
        ? _c(
            "a-popover",
            {
              attrs: {
                id: "popoverHelpMenu",
                "data-v-step": "4",
                placement: "bottom",
                title: "",
                trigger: "click",
              },
              model: {
                value: _vm.popovers.isHelpMenuPopoverOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.popovers, "isHelpMenuPopoverOpen", $$v)
                },
                expression: "popovers.isHelpMenuPopoverOpen",
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { attrs: { id: "popoverHelpMenuOpened" } },
                  [
                    !_vm.isAdmin
                      ? _c("div", { staticClass: "d-flex flex-row mt-3" }, [
                          _c(
                            "div",
                            { staticClass: "justify-content-start" },
                            [_c("keyboard")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "justify-content-end pl-3 popoverFont cursorPointer",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleKeyboardShotcutModal(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.keyboardShortcuts")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-2 popoverFont justify-content-end popoverFont cursorPointer",
                        staticStyle: {
                          display: "inline-flex",
                          "align-items": "center",
                          cursor: "pointer",
                        },
                        on: { click: _vm.showModal },
                      },
                      [
                        _c("a-icon", {
                          staticClass: "mr-3",
                          staticStyle: {
                            "font-size": "18px",
                            color: "#48b6e7",
                          },
                          attrs: { type: "file-pdf" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "font-size": "14px" } }, [
                          _vm._v(_vm._s(_vm.$t("message.supsisDocument"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isAdmin
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex flex-row",
                            staticStyle: {
                              "margin-top": "10px",
                              "margin-bottom": "-10px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "justify-content-start" },
                              [_c("NewIcon")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "justify-content-end pl-3 popoverFont cursorPointer",
                                on: { click: _vm.openNewsModal },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("message.news")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("NewsModal", { ref: "newsModal" }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-row mt-3 mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "justify-content-start" },
                        [
                          _c(
                            "md-icon",
                            {
                              staticStyle: {
                                color: "red",
                                width: "20px !important",
                                "min-width": "20px !important",
                                height: "20px !important",
                                "font-size": "20px !important",
                              },
                            },
                            [_vm._v("support\n                        ")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-end pl-3 popoverFont cursorPointer",
                          on: { click: _vm.integrationInstruction },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.notIntegrated")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "d-flex flex-row mt-3": !_vm.isAdmin,
                          "d-flex flex-row": _vm.isAdmin,
                        },
                      },
                      [
                        _c("div", { staticClass: "justify-content-start" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "20px !important" },
                            },
                            [_vm._v("help_center")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end pl-3 popoverFont cursorPointer",
                            on: { click: _vm.connectSupportTeamRequest },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.supportUs")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "d-flex flex-row mt-3": !_vm.isAdmin,
                          "d-flex flex-row": _vm.isAdmin,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "md-icon",
                              {
                                style: {
                                  color: _vm.darkMode ? "yellow" : "black",
                                },
                              },
                              [_vm._v("report")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end pl-3 popoverFont cursorPointer",
                            on: { click: _vm.makeBugReport },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.reportBug")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "d-flex flex-row mt-3": !_vm.isAdmin,
                          "d-flex flex-row": _vm.isAdmin,
                        },
                      },
                      [
                        _c("div", { staticClass: "justify-content-start" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "20px !important" },
                            },
                            [_vm._v("apps")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end pl-3 popoverFont cursorPointer",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("/supsis-app")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.getApps")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "d-none flex-row mt-3": !_vm.isAdmin,
                          "d-none flex-row": _vm.isAdmin,
                        },
                      },
                      [
                        _c("div", { staticClass: "justify-content-start" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "20px !important" },
                            },
                            [_vm._v("help_center")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end pl-3 popoverFont cursorPointer",
                            on: {
                              click: function ($event) {
                                return _vm.openPDF()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.help")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("AnnouncementNotifications"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "d-flex flex-row mt-2": !_vm.isAdmin,
                          "d-flex flex-row": _vm.isAdmin,
                        },
                      },
                      [
                        _c("div", { staticClass: "justify-content-start" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "20px !important" },
                            },
                            [_vm._v("done")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "justify-content-end pl-3 popoverFont",
                          },
                          [_vm._v("SUPSIS " + _vm._s(_vm.version.versionStr))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "custom-button",
                  class: { infoLight: _vm.unreadAnnouncements },
                },
                [
                  _vm.unreadAnnouncements
                    ? _c(
                        "a-badge",
                        { attrs: { color: "#F64E60" } },
                        [_c("Question")],
                        1
                      )
                    : _c("Question"),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "notifications" } },
        [
          !_vm.blockedConnection
            ? _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomRight",
                    trigger: "click",
                    overlayClassName: "no-padding notification-popover",
                  },
                  model: {
                    value: _vm.popovers.notifications,
                    callback: function ($$v) {
                      _vm.$set(_vm.popovers, "notifications", $$v)
                    },
                    expression: "popovers.notifications",
                  },
                },
                [
                  _c(
                    "template",
                    { staticClass: "zero-padding p-0", slot: "content" },
                    [
                      _vm.popovers.notifications
                        ? _c("NotificationPanel")
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    { staticClass: "custom-button notification" },
                    [
                      _vm.unreadNotificationCount !== 0
                        ? _c("SupsisBadge", {
                            attrs: {
                              badge: _vm.unreadNotificationCount.toString(),
                              "class-name": "activty-undread-count",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("notifications"),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-selection-item" },
        [
          _vm.adminUser
            ? _c(
                "b-dropdown",
                {
                  staticClass: "h-100",
                  attrs: {
                    id: "user-dropdown",
                    text: _vm.adminUser.email,
                    right: "",
                  },
                },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("img", {
                      staticClass: "rounded-circle mx-1",
                      attrs: {
                        alt: "Kullanıcı resmi",
                        src: "https://placeimg.com/30/30/people",
                      },
                    }),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(_vm.adminUser.name))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "mt-2",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "sign-out-alt" },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.logout")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "conversation-color-help2",
                footer: null,
                title: _vm.$t("message.chatColorMeanings"),
                visible: _vm.chatColorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
                ok: function ($event) {
                  return _vm.toggleChatColorModal(false)
                },
              },
            },
            [_c("ConversationColorHelp")],
            1
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "ShortcutModal",
                footer: null,
                title: _vm.$t("message.keyboardShortcuts"),
                visible: _vm.keyboardShortCutsModalVisible,
              },
              on: {
                cancel: function ($event) {
                  return _vm.toggleKeyboardShotcutModal(false)
                },
              },
            },
            [_c("KeyboardShortcuts")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "debug-tool-modal-wrapper",
          attrs: { title: "Debug Tool", footer: null },
          model: {
            value: _vm.debugToolVisible,
            callback: function ($$v) {
              _vm.debugToolVisible = $$v
            },
            expression: "debugToolVisible",
          },
        },
        [_c("DebugTool")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }